<app-header></app-header>

<ion-content>
  <ion-grid fixed class="h-100 display-flex ion-justify-content-center">
    <ion-row class="page-not-found__container">
      <ion-col size="1" *ngIf="!p.renderSmallDesktop"> </ion-col>
      <ion-col size-xl="5" size="12" class="page-not-found__left-column">
        <h1 class="page-not-found__header">Brak dostępu</h1>
        <p class="page-not-found__description">
          Aby uzyskać dostęp do tego modułu, skontaktuj się z
          <a href="mailto:kontakt@space-tech.it">kontakt&#64;space-tech.it</a>
        </p>
        <ion-back-button
          defaultHref="app/home"
          [icon]="undefined"
          color="primary"
          class="page-not-found__link-button"
          text="Wróc do strony głównej"
        >
        </ion-back-button>
      </ion-col>
      <ion-col size-xl="5" size="12" class="page-not-found__right-column">
        <img
          src="./../../assets/images/404.png"
          alt="404"
          class="page-not-found__image"
        />
      </ion-col>
      <ion-col size="1" *ngIf="!p.renderSmallDesktop"> </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
